import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import {
	MatDialogRef,
	MatPaginator,
	MatSort,
	MAT_DIALOG_DATA,
} from "@angular/material";
import { MatTableDataSource } from "@angular/material/table";
import * as Excel from 'exceljs/dist/exceljs';
import { FormControl } from '@angular/forms';
import * as XLSX from 'ts-xlsx';

@Component({
	selector: "m-dialog-resultado-blacklist",
	templateUrl: "./dialog-resultado-blacklist.component.html",
	styleUrls: ["./dialog-resultado-blacklist.component.scss"],
})
export class DialogResultadoBlacklistComponent implements OnInit {
	viewLoading: boolean = false;
	listData: MatTableDataSource<any> = new MatTableDataSource([]);

	displayedColumns: string[] = ["DNI", "Respuesta"];

	@ViewChild("ASIGMatPaginator", { read: MatPaginator })
	ASIGMatPaginator: MatPaginator;
	@ViewChild("ASIGMatSort") ASIGMatSort: MatSort;
	load_data: boolean = true;
	no_data: boolean = false;

	array_dataList: any = [];
	toastr: any;

	constructor(
		public dialogRef: MatDialogRef<DialogResultadoBlacklistComponent>,
		private _formBuilder_lote: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {
		this.listData = new MatTableDataSource(this.data.items);
		this.array_dataList = this.data.items;
		this.no_data = true;
		this.listData.sort = this.ASIGMatSort;
		this.listData.paginator = this.ASIGMatPaginator;
	}

	onNoClick(): void {
		this.dialogRef.close();
	}


	blobType: string = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	sName: string;
	excelFileName: string;
	cols: string[] = [
		"DNI", "Respuesta"
	];
	exportar() {
		this.array_dataList = this.data.items;
		if (this.array_dataList.length > 0) {
			this.sName = "Rpt Lista Personas Blacklist que no fueron registradas por estar duplicados";
			this.excelFileName = `${this.sName}.xlsx`;
			const workbook = new Excel.Workbook();
			workbook.creator = "Web";
			workbook.lastModifiedBy = "Web";
			workbook.created = new Date();
			workbook.modified = new Date();
			workbook.addWorksheet(this.sName, {
				views: [
					{
						ySplit: 0,
						xSplit: 20,
						activeCell: "A1",
						showGridLines: true,
					},
				],
			});
			const sheet = workbook.getWorksheet(1);
			sheet.getColumn(1).width = 30;
			sheet.getRow(1).values = this.cols;

			sheet.columns = [
				{ key: "DNI", width: 25 },
				{ key: "Respuesta", width: 60 },
			];

			["A1", "B1", "C1", "D1"].map((key) => {
				sheet.getCell(key).fill = {
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "eaeaea" },
				};
			});
			this.array_dataList.forEach((item) => {
				sheet.addRow({
					DNI: item.DocIdentidad,
					Respuesta: item.Respuesta,
				});
			});

			workbook.xlsx.writeBuffer().then((dataReporte) => {
				var file = new Blob([dataReporte], { type: this.blobType });
				if (window.navigator.msSaveOrOpenBlob)
					// IE10+
					window.navigator.msSaveOrOpenBlob(file, this.excelFileName);
				else {
					// Others
					var a = document.createElement("a"),
						url = URL.createObjectURL(file);
					a.href = url;
					a.download = this.excelFileName;
					document.body.appendChild(a);
					a.click();
					setTimeout(function () {
						document.body.removeChild(a);
						window.URL.revokeObjectURL(url);
					}, 0);
				}
			});
		}else {
			this.toastr.warningToastr("Sin datos para migrar", "Advertencia!", {
				toastTimeout: 2000,
				showCloseButton: true,
				animate: "fade",
				progressBar: true,
			});
		}
	}
}
